<app-widget-option [categories]="['INDICATORS']" [label]="'AUTOMATIC_DUPLICATION'">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="autoDuplicate" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-widget-option>